import React from 'react';
import { HighlightsListInput } from './HighlightsListInput';

interface HighlightItem {
  id?: string | number;
  title: string;
  titleLink?: string;
  description: string;
}

interface HighlightsFieldProps {
  label: string;
  required?: boolean;
  value: HighlightItem[];
  onChange: (_items: HighlightItem[]) => void;
  error?: string;
}

export const HighlightsField: React.FC<HighlightsFieldProps> = ({
  label,
  required,
  value,
  onChange,
  error
}) => {
  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <HighlightsListInput value={value} onChange={onChange} />
      {error && (
        <p className="text-red-500 text-sm">{error}</p>
      )}
    </div>
  );
};

